if (!customElements.get('vm-size-guide')) {
  customElements.define('vm-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tablist = this.querySelector('[data-size-tabs]');
      const tabs = [...tablist.querySelectorAll('a')];
      const panels = [...this.querySelectorAll('[data-size-panel]')];
      const units = this.querySelector('[data-size-units]');
      tablist.setAttribute('role', 'tablist');
      const activate = (tab, focus = false) => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = `#${panel.id}` !== tab.hash; });
        units.hidden = tab.hash !== '#sizes-women';
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        const panel = panels.find(item => `#${item.id}` === tab.hash);
        if (!panel) return;
        tab.id = `${panel.id}-tab`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); activate(tab); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        });
      });
      units.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        const metric = button.dataset.unit === 'cm';
        this.querySelectorAll('[data-inch]').forEach(cell => {
          const value = Number(cell.dataset.inch) * (metric ? 2.54 : 1);
          cell.textContent = String(Math.round(value * 10) / 10);
        });
        this.querySelectorAll('[data-unit-name]').forEach(label => { label.textContent = metric ? this.dataset.cmLabel : this.dataset.inchLabel; });
        units.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      activate(tabs.find(tab => tab.hash === window.location.hash) || tabs[0]);
    }
  });
}
